import React, { useEffect, useState } from 'react';
import { Spinner } from '@chakra-ui/react';
import { MokkiCalendar } from './MokkiCalendar/MokkiCalendar';
import { useParams } from 'react-router';
import { CalendarApi } from '../../API/sdk';
import { CalendarProductDto } from '../../API';
import { Language, LanguageId, toLanguageId } from '../../Constants/Language';
import i18n from '../../Translation/Translation';

export enum SelectionType {
	day = 0,
	continuous = 1
}

export interface IMokkiPackage {
	name: string;
	description: string;
	selfcareDescription?: string;
	year: number;
	minSelected: number;
	maxSelected: number;
	currentSelected: number;
	selectionType: SelectionType;
	availableYears?: number[];
	days: {
		isSelected: boolean;
		id: number;
		isLocked: boolean;
		dateString: string;
		date: Date;
	}[];
}

export type CalendarChange = { id: number; isSelected: boolean };

export const CalendarPage = () => {
	const [year, setYear] = useState<string>(new Date().getFullYear().toString());
	const [mokkiCalendar, setMokkiCalendar] = useState<IMokkiPackage | null>();
	const { orderid, orderrowid } = useParams<{ orderid: string; orderrowid: string }>();
	const localeLang = i18n.language;

	useEffect(() => {
		updateCalendar(year, orderid, orderrowid);
	}, [year, orderid, orderrowid, localeLang]);

	const refreshCalendar = () => updateCalendar(year, orderid, orderrowid);

	const updateCalendar = async (year: string, orderId: string, orderRowId: string) => {
		//parse params
		const pOrderId = parseInt(orderId);
		const pOrderRowId = parseInt(orderRowId);
		const pYear = parseInt(year);

		// gatekeeper, proceed only with number values
		if (Number.isNaN(pOrderId) || Number.isNaN(pOrderRowId) || Number.isNaN(pYear)) return;

		//get calendar
		const result = await CalendarApi.getCustomerCalendarProduct(
			pYear,
			pOrderId,
			pOrderRowId,
			toLanguageId[localeLang] ?? LanguageId.finnish
		);

		if (!result.data) return; // gateguard
		const data = result.data as CalendarProductDto;

		setMokkiCalendar({
			...data,
			selfcareDescription: data.selfCareDescription,
			selectionType: data.selectionType as unknown as SelectionType,
			days: data.days.map((item) => ({ ...item, date: new Date(item.dateString), id: item.id }))
		});
	};

	const submitCalenderChanges = (values: CalendarChange[]) => {
		// console.table(values);
		const pOrderId = parseInt(orderid);
		const pOrderRowId = parseInt(orderrowid);
		const pYear = parseInt(year);

		// gatekeeper, proceed only with number values
		if (Number.isNaN(pOrderId) || Number.isNaN(pOrderRowId) || Number.isNaN(pYear))
			return Promise.reject();

		return CalendarApi.postChangedCalenderProductDays({
			orderId: pOrderId,
			orderRowId: pOrderRowId,
			year: pYear,
			days: values
		});
	};

	return (
		<>
			{mokkiCalendar ? (
				<MokkiCalendar
					product={mokkiCalendar}
					save={submitCalenderChanges}
					refreshCalendar={refreshCalendar}
					setYear={setYear}
					year={parseInt(year)}
				/>
			) : (
				<Spinner></Spinner>
			)}
		</>
	);
};
